module.exports = __webpack_public_path__ + "img/zgysjw.33b88714.png";